/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import ModuleEditorStore from 'InpageEditorUI/lib/ModuleEditorStore';
import timeout from 'hs-promise-utils/timeout';
const MAX_WAIT = 2000;
const getErrorResponse = error => {
  if (error && typeof error === 'string') {
    return {
      error
    };
  }
  if (error && error.message && typeof error.message === 'string') {
    return {
      error: error.message
    };
  }
  return {
    error: 'Unknown error checking for inpage updates'
  };
};
export const getCheckForPendingInpageUpdate = (eventBus, getAllWidgets) => message => {
  try {
    const allWidgets = getAllWidgets();
    if (allWidgets) {
      const pendingUpdates = allWidgets.map(widget => {
        const editor = ModuleEditorStore.get(widget.name);
        if (editor) {
          return editor.getPendingUpdate();
        }
        return null;
      }).filter(pendingUpdate => pendingUpdate);
      const count = pendingUpdates.length;
      if (count) {
        const promise = timeout(Promise.all(pendingUpdates), MAX_WAIT, `Timed out waiting for ${count} pending inpage update(s)`);
        promise.then(resolvedUpdates => eventBus.messenger.postResponse(message, {
          resolvedUpdates,
          processedUpdates: true
        }), error =>
        // There was either an error in one of the pending updates, or we timed out waiting for them
        eventBus.messenger.postResponse(message, getErrorResponse(error)));
        return promise;
      }
    }
  } catch (e) {
    // Some unknown JS error gathering up the pending updates
    return Promise.resolve(eventBus.messenger.postResponse(message, getErrorResponse(e)));
  }

  // No updates to wait for, go ahead and save
  return Promise.resolve(eventBus.messenger.postResponse(message, {
    processedUpdates: false
  }));
};
export const bindCheckForPendingInpageUpdates = (eventBus, getAllWidgets) => {
  eventBus.on('post:checkForPendingInpageUpdates', getCheckForPendingInpageUpdate(eventBus, getAllWidgets));
};